import { Component, OnInit, Inject } from '@angular/core';
import { environment, ConstVariable } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { LookupInfo } from '../../model/lookup.model';
import { GlobalService } from '../../service/global.service';
import { TokenService } from '../../service/token.service';
import { StateMappingInfo } from '../../model/StateMappingInfo.model';
import { Router } from '@angular/router';
import { CycleInfo } from '../../model/CycleInfo.model';
import { StateInfo } from '../../model/StateInfo.model';
import { SubStateInfo } from '../../model/SubStateInfo.model';

@Component({
  selector: 'app-statestatus-mapping',
  templateUrl: './statestatus-mapping.component.html',
  styleUrls: ['./statestatus-mapping.component.css']
})
export class StatestatusMappingComponent implements OnInit {
  /************************* Variables ************************** */
  baseurl: string;
  _EmpCode: string;

  //StateMapping Model
  ListStatus: LookupInfo[] = [];
  ListCycle: CycleInfo[] = [];
  ListState: StateInfo[] = [];
  ListSubState: SubStateInfo[] = [];
  ListStateMappingManagement: StateMappingInfo[] = [];
  StateMappingInfo: StateMappingInfo = new StateMappingInfo;

  //Search
  isSearchSubmitted: boolean = false;
  txtSchCycleCode: string
  txtSchCycleName: string
  txtSchStateCode: string;
  txtSchStateName: string;
  txtSchSubStateCode: string;
  txtSchSubStateName: string;
  ddlSchStateMappingStatus: string = "";

  //Form variable
  StateMappingForm: FormGroup;
  IsDuplicateCode: boolean;

  //Pagination
  indexNo: number = 0;
  currentPageNumber: number = 1;
  totalStateMapping: number = 0;
  totalPages: number = 0;
  pageSize: number;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;


  /************************* End Variables ************************** */
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private router: Router) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {

    //Init data
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSizeMedium;
    this._EmpCode = localStorage.getItem("EmpCode");
    this.ddlSchStateMappingStatus = 'Y'

    //Load init data
    this.LoadLookupType("MASTERSTATUS").then((data) => {
      this.ListStatus = data;
    });

    this.LoadCycleList().then((data) => {
      this.ListCycle = data;
    });
    this.LoadStateList().then((data) => {
      this.ListState = data;
    });
    this.LoadSubStateList().then((data) => {
      this.ListSubState = data;
    });
    this.LoadStateMappingList().then((data) => {
      this.ListStateMappingManagement = data;
    });
    this.LoadCountStateMappingList();

    //Declare form
    this.StateMappingForm = new FormGroup({
      CycleCode: new FormControl(this.StateMappingInfo.CycleCode, [Validators.required]),
      StateCode: new FormControl(this.StateMappingInfo.StateCode, [Validators.required]),
      SubStateCode: new FormControl(this.StateMappingInfo.SubStateCode),
      FlagActive: new FormControl(this.StateMappingInfo.FlagActive),
    });
  }

  get CycleCode() { return this.StateMappingForm.get('CycleCode'); }
  get StateCode() { return this.StateMappingForm.get('StateCode'); }
  get SubStateCode() { return this.StateMappingForm.get('SubStateCode'); }

  async LoadLookupType(LookupType) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = LookupType;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise();
    }
  }
  async LoadCycleList(dataId: number = 0): Promise<CycleInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeMedium;
      var objectjson = {};
      objectjson['Id'] = dataId;
      objectjson['CycleCode'] = this.txtSchCycleCode;
      objectjson['CycleName'] = this.txtSchCycleName;

      objectjson['rowFetch'] = environment.PageSizeMedium;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<CycleInfo[]>(this.baseurl + "MasterSale/GetCycleManagementList", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadStateList(dataId: number = 0): Promise<StateInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      
      var objectjson = {};
      objectjson['Id'] = dataId;
      objectjson['StateCode'] = this.txtSchStateCode;
      objectjson['StateName'] = this.txtSchStateName;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<StateInfo[]>(this.baseurl + "MasterSale/GetStateManagementList", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadSubStateList(dataId: number = 0): Promise<SubStateInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeMedium;
      var objectjson = {};
      objectjson['Id'] = dataId;
      objectjson['SubStateCode'] = this.txtSchSubStateCode;
      objectjson['SubStateName'] = this.txtSchSubStateName;

      objectjson['rowFetch'] = environment.PageSizeMedium;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<SubStateInfo[]>(this.baseurl + "MasterSale/GetSubStateManagementList", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadStateMappingList(dataId: number = 0): Promise<StateMappingInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeMedium;
      var objectjson = {};
      objectjson['Id'] = dataId;
      objectjson['StateCode'] = this.txtSchStateCode;
      objectjson['StateName'] = this.txtSchStateName;
      objectjson['SubStateCode'] = this.txtSchSubStateCode;
      objectjson['SubStateName'] = this.txtSchSubStateName;

      objectjson['rowFetch'] = environment.PageSizeMedium;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<StateMappingInfo[]>(this.baseurl + "MasterSale/GetMappingStateStatusList", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadCountStateMappingList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['StateCode'] = this.txtSchStateCode;
      objectjson['StateName'] = this.txtSchStateName;
      objectjson['SubStateCode'] = this.txtSchSubStateCode;
      objectjson['SubStateName'] = this.txtSchSubStateName;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<number>(this.baseurl + "MasterSale/GetCountMappingStateStatusList", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SetTotalpagePagination(data);
        });
    }
  }

  OnSearch_Click() {
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = true;
    this.LoadStateMappingList().then((data) => {
      this.ListStateMappingManagement = data;
    });
  }
  OnClear_Click() {
    //this.txtSchStateMappingCode = null;
    //this.txtSchStateMappingName = null;
    $('#ddlSchStateMappingStatus').val('')

    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = false;
    this.LoadStateMappingList().then((data) => {
      this.ListStateMappingManagement = data;
    });
  }

  //Create btn
  OnCreateStateMapping_Click() {

    $('#modalCreateStateMappingTitle').html('Create StateMapping DOA');
    $('#modalCreateOrEditStateMapping').modal();
    this.StateMappingInfo = new StateMappingInfo;
    this.CycleCode.setValue(null);
    this.StateCode.setValue(null);
    this.SubStateCode.setValue(null);

    this.StateMappingForm.markAsUntouched();
    this.StateMappingForm.markAsPristine();
  }

  async OnSubmitCreateStateMapping_Click() {
    if (this.StateMappingForm.valid && !this.IsDuplicateCode) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.StateMappingForm.value;
        objectjson['CycleCode'] = this.StateMappingForm.get('CycleCode').value;
        objectjson['StateCode'] = this.StateMappingForm.get('StateCode').value;
        objectjson['SubStateCode'] = this.StateMappingForm.get('SubStateCode').value;
        objectjson['FlagActive'] = this.StateMappingForm.get('FlagActive').value;
        objectjson['CreateBy'] = this._EmpCode;

        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "MasterSale/InsertMappingStateStatus", strjson, httpOptions)
          .toPromise().then((data) => {
            this.titlemodal = '';
            this.detailmodal = 'StateMapping has been created successfully.';
            $('#ModalComplate .modal-header').text('Information');
            $('#ModalComplate .modal-header').addClass('bg-gold');
            $('#ModalComplate').modal();
            $('#modalCreateOrEditStateMapping').modal('hide');

            //Reload
            this.currentPageNumber = 1;
            this.LoadStateMappingList().then((data) => {
              
              this.ListStateMappingManagement = data;
            });
            this.LoadCountStateMappingList();
          });
      }
    } else {
      this.markFormGroupTouched(this.StateMappingForm);
    }

  }
  async OnEdit_Click(StateMappingId) {

    if (!!StateMappingId) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadStateMappingList(StateMappingId).then((data) => {

          this.StateMappingInfo = data[0];
          this.CycleCode.setValue(data[0].CycleCode);
          this.StateCode.setValue(data[0].StateCode);
          this.SubStateCode.setValue(data[0].SubStateCode);
          this.StateMappingForm.get("FlagActive").setValue(data[0].FlagActive);

          setTimeout(() => {

            $('#modalCreateStateMappingTitle').html('Edit StateMapping DOA');
            $('#modalCreateOrEditStateMapping').modal();
          }, 500);
        });
      }
    }
  }
  async OnSubmitEdit_Click() {
    if (this.StateMappingForm.valid && !this.IsDuplicateCode) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        //ปรับ flag ก่อนนำไป save ลง DB
        var objectjson = this.StateMappingForm.value;
        objectjson['CycleCode'] = this.StateMappingForm.get('CycleCode').value;
        objectjson['StateCode'] = this.StateMappingForm.get('StateCode').value;
        objectjson['SubStateCode'] = this.StateMappingForm.get('SubStateCode').value;
        objectjson['FlagActive'] = this.StateMappingForm.get('FlagActive').value;
        
        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['Id'] = this.StateMappingInfo.Id;


        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "MasterSale/UpdateMappingStateStatus", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {
              this.titlemodal = '';
              this.detailmodal = 'StateMapping has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();
              $('#modalCreateOrEditStateMapping').modal('hide');

              //Reload
              this.LoadStateMappingList().then((data) => {
                this.ListStateMappingManagement = data;
              });
            } else {
              this.titlemodal = 'Fail.';
              this.detailmodal = 'Position was updated fail.';
              $('#ModalError').modal();
              $('#modalCreateOrEditStateMapping').modal('hide');

            }
          });
      }
    } else {
      this.markFormGroupTouched(this.StateMappingForm);
    }
  }
  async OnDelete_Click(StateMappingId) {
    if (!!StateMappingId) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.StateMappingForm.value;
        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['Id'] = StateMappingId;

        let arrjson: StateMappingInfo[] = [];
        arrjson.push(objectjson);
        let strjson = JSON.stringify(arrjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "MasterSale/DeleteMappingStateStatus", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {
              this.isSearchSubmitted = false;
              this.titlemodal = '';
              this.detailmodal = 'StateMapping has been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              //Reload
              this.LoadStateMappingList().then((data) => {
                this.ListStateMappingManagement = data;
              });

            }
            else {

              this.titlemodal = 'Fail.';
              this.detailmodal = 'Delete fail.';
              $('#ModalError').modal();

            }
          });
      }
    }
  }
  async OnDeleteList_Click() {
    var listDeleteChecked = $('[name="checkboxdelete"]:checked');
    let arrjson: StateMappingInfo[] = [];

    //เก็บ List id ที่จะ delete
    $.each(listDeleteChecked, function (idx, val) {
      var curId = $(val).data('positionid');
      var model = new StateMappingInfo;
      model.Id = curId;
      arrjson.push(model);
    });

    if (arrjson.length > 0) {
      if (confirm("Are you sure to delete these DOA?")) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          //ส่งไป Delete
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
          let strjson = JSON.stringify(arrjson);

          console.log(strjson);

          this.httpClient.post<any>(this.baseurl + "MasterSale/DeleteMappingStateStatus", strjson, httpOptions)
            .toPromise().then((data) => {
              if (!!data) {

                this.titlemodal = '';
                this.detailmodal = 'StateMappings have been deleted successfully.';
                $('#ModalComplate .modal-header').text('Information');
                $('#ModalComplate .modal-header').addClass('bg-gold');
                $('#ModalComplate').modal();

                setTimeout(() => {
                  this.isSearchSubmitted = false;
                  //Reload
                  this.LoadStateMappingList().then((data) => {
                    this.ListStateMappingManagement = data;
                  });
                  this.LoadCountStateMappingList()
                }, 500);


              }
              else {

                this.titlemodal = 'Fail.';
                this.detailmodal = 'Delete fail.';
                $('#ModalError').modal();

              }
            });
        }
      }
    } else {

      this.titlemodal = 'Fail.';
      this.detailmodal = 'Please select DOA to delete at least 1 row.';
      $('#ModalError .modal-header').text("Sorry");
      $('#ModalError').modal();
    }
  }
 
  //Pagination
  OnLoadListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
      this.indexNo = traget.index;
    }

    this.LoadStateMappingList().then((data) => {
      this.ListStateMappingManagement = data;
    });;
  }
  SetTotalpagePagination(data) {
    this.totalStateMapping = data;
    if (this.totalStateMapping == 0) {
      this.currentPageNumber = 0;
    }
    this.totalPages = Math.ceil(this.totalStateMapping / environment.PageSizeMedium);
  }

  //Private function
  private Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();


      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
